import React, { useEffect, useState } from "react";
import AdminLTE, {
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
} from "adminlte-2-react";
import _ from "lodash";
import moment from "moment";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { validateEmail } from "../utils/utils";
import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";
import SelectInput from "../utils/SelectInput";
import PYG from "../utils/PYG";
import controllerLocal from "../locales/duck";

const crearAsistenciaOptions = () => [
  { value: "SI", label: "SI" },
  { value: "NO", label: "NO" },
];

const { Text } = Inputs;

function AddContacto({ history, match }) {
  const dispatch = useDispatch();

  const modelAddAsitencia = useSelector((state) => state.addAsistencia);
  const modelContacto = useSelector((state) => state.getContactoByDocument);
  const modelReservas = useSelector((state) => state.reservaOptions);
  const modelLocal = useSelector((state) => state.localById);

  const [reservaOptions, setReservaOptions] = useState([]);
  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [documento, setDocumento] = useState("");
  const [documentoSearch, setDocumentoSearch] = useState("");
  const [direccion, setDireccion] = useState("");
  const [email, setEmail] = useState("");
  const [ts, setTs] = useState(moment().format("YYYY-MM-DD"));
  const [localId, setLocalId] = useState(match.params.localId);

  const [crearAsistencia, setCrearAsistencia] = useState("SI");
  const [poseeReserva, setPoseeReserva] = useState("NO");
  const [reserva, setReserva] = useState(null);
  const [contacto, setContacto] = useState(null);
  const [valorEntrada, setValorEntrada] = useState("");
  const [fechaNacimiento, setFechaNacimiento] = useState("");
  const [camposContacto, setCamposContacto] = useState(null);


  useEffect(() => {
    dispatch(controller.getReservaOptionsThunk({ id: match.params.localId }));
    dispatch(controllerLocal.localByIdThunk(match.params.localId));
  }, []);

  useEffect(() => {
    const data = modelLocal?.data?.data;
    const error = modelLocal?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerLocal.duckLocalById.actions.clear());
    }
    if (data && data.data) {
    

      if (data.data.detalles.camposContacto) {
        setCamposContacto(data.data.detalles.camposContacto);
      }

      dispatch(controllerLocal.duckLocalById.actions.clear());
    }
  }, [modelLocal]);

  useEffect(() => {
    const data = modelAddAsitencia?.data?.data;
    const error = modelAddAsitencia?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckAddAsistencia.actions.clear());
    }
    if (data) {
      alert("Asistencia generada");
      setNombre("");
      setTelefono("");
      setDocumento("");
      setDocumentoSearch("");
      setPoseeReserva("NO");
      setDireccion("");
      setEmail("");
      setTs("");
      setLocalId("");
      setContacto("");
      setFechaNacimiento("");
      setValorEntrada("");
      setReserva(null);
      dispatch(controller.duckAddAsistencia.actions.clear());
    }
  }, [modelAddAsitencia]);

  useEffect(() => {
    const data = modelReservas?.data?.data;
    const error = modelReservas?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckReservaOptions.actions.clear());
    }
    if (data) {
  
      setReservaOptions(data.data);
      dispatch(controller.duckReservaOptions.actions.clear());
    }
  }, [modelReservas]);

  useEffect(() => {
    const data = modelContacto?.data?.data;
    const error = modelContacto?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckContactoByDocument.actions.clear());
    }
    if (data) {
    
      if (data.data) {
        setNombre(data.data.nombre);
        setTelefono(data.data.telefono);
        setDocumento(data.data.documento);
        setDireccion(data.data.direccion);
        setEmail(data.data.email);
        setTs(data.data.ts);
        setLocalId(data.data.localId);
        setContacto(data.data);
        if (data.data.fechaNacimiento) {
          setFechaNacimiento(new Date(data.data.fechaNacimiento));
        }
      } else {
        setDocumento(documentoSearch);
      }

      dispatch(controller.duckContactoByDocument.actions.clear());
    }
  }, [modelContacto]);

  function search() {
    if (!documentoSearch) {
      alert("Por favor proporcione un documento");
      return;
    }

    let data = {
      documento: documentoSearch,
    };

    dispatch(controller.getContactoByDocumentThunk(data));
  }

  function submit() {
    if (
      camposContacto?.fechaNacimiento?.habilitado &&
      camposContacto?.fechaNacimiento?.required && !fechaNacimiento
    ) {
      alert("Por favor ingrese una fecha de nacimiento");
      return;
    }
    if (
      camposContacto?.direccion?.habilitado &&
      camposContacto?.direccion?.required && !direccion
    ) {
      alert("Por favor ingrese una direccion");
      return;
    }
    if (camposContacto?.email?.habilitado && camposContacto?.email?.required && !email) {
      alert("Por favor ingrese un email");
      return;
    }
    if (email && !validateEmail(email)) {
      alert("Por favor proporcione un email con el formato correcto");
      return;
    }

    if (
      camposContacto?.telefono?.habilitado &&
      camposContacto?.telefono?.required && !telefono
    ) {
      alert("Por favor ingrese un numero de telefono");
      return;
    }
    if (!nombre || !documento) {
      alert("Por favor ingrese el nombre y documento");
      return;
    }

    if (!localId) {
      alert("No se ha podido obtener el ID del local");
      return;
    }
    if (poseeReserva === "SI" && !reserva) {
      alert("Seleccione una reserva");
      return;
    }

    let data = {
      id: contacto ? contacto._id : null,
      _id: contacto ? contacto._id : null,
      nombre,
      telefono,
      documento: contacto ? contacto.documento : documento,
      ts,
      direccion,
      email,
      localId,
      crearAsistencia,
      reserva: reserva ? reserva : null,
      valorEntrada,
      fechaNacimiento,
    };

    dispatch(controller.addAsistenciaThunk(data));
  }

  return (
    <Content
      title="Nueva asitencia"
      browserTitle="Nuevo asitencia"
      show={false}
    >
      <Row>
        <Col md="4" mdOffset="4">
          <Box
            title="Nuevo asitencia"
            footer={
              <>
                <Button text="Cancelar" onClick={() => history.goBack()} />

                <Button
                  type="primary"
                  text="Guardar"
                  pullRight={true}
                  disabled={modelAddAsitencia.loading}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <ReferenciaObligatorios />
            <div style={{ marginBottom: 30 }}>
              <Text
                labelPosition="above"
                size="sm"
                inputType="number"
                label={<Etiqueta texto="Documento" obligatorio={true} />}
                value={documentoSearch}
                onChange={(evt) => setDocumentoSearch(evt.target.value)}
              />
              <Button
                type="primary"
                text="Buscar"
                disabled={modelContacto.loading}
                onClick={() => search()}
              />
            </div>
            {crearAsistencia === "SI" ? (
              <SelectInput
                value={poseeReserva}
                setValue={setPoseeReserva}
                label="Posee reserva"
                options={crearAsistenciaOptions()}
              />
            ) : null}
            {poseeReserva === "SI" ? (
              <SelectInput
                value={reserva}
                setValue={setReserva}
                label="SeleccionarReserva"
                options={reservaOptions}
              />
            ) : null}
            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Documento" obligatorio={true} />}
              value={documento}
              disabled
              onChange={(evt) => setDocumento(evt.target.value)}
            />

            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Nombre" obligatorio={true} />}
              value={nombre}
              disabled={contacto ? true : false}
              onChange={(evt) => setNombre(evt.target.value)}
            />
            {camposContacto?.telefono?.habilitado ? (
              <Text
                labelPosition="above"
                size="sm"
                label={camposContacto?.telefono?.required ? <Etiqueta texto="Telefono" obligatorio={true} /> : "Telefono"}
                value={telefono}
                inputType="number"
                disabled={contacto ? true : false}
                onChange={(evt) => setTelefono(evt.target.value)}
              />
            ) : null}

            {camposContacto?.email?.habilitado ? (
              <Text
                labelPosition="above"
                size="sm"
                label={camposContacto?.email?.required ? <Etiqueta texto="Email" obligatorio={true} /> : "Email"}
                value={email}
                disabled={contacto ? true : false}
                onChange={(evt) => setEmail(evt.target.value)}
              />
            ) : null}

            {camposContacto?.direccion?.habilitado ? (
              <Text
                labelPosition="above"
                size="sm"
                label={camposContacto?.direccion?.required ? <Etiqueta texto="Direccion" obligatorio={true} /> : "Direccion"}
                value={direccion}
                disabled={contacto ? true : false}
                onChange={(evt) => setDireccion(evt.target.value)}
              />
            ) : null}

            <PYG
              // react-number-format's props
              value={valorEntrada}
              isNumericString={true}
              displayType="input"
              onValueChange={(values) => {
                const { formattedValue, value } = values;
                setValorEntrada(value);
              }}
              decimalScale={0}
              customInput={Text}
              // adminlte-2-react's Text's props
              labelPosition="above"
              size="sm"
              label="Valor de la entrada"
            />
            {camposContacto?.fechaNacimiento?.habilitado ? (
              <div style={{ marginBottom: 15 }}>
                <label>{camposContacto?.fechaNacimiento?.required ? <Etiqueta texto="Fecha de nacimiento" obligatorio={true} /> : "Fecha de nacimiento"}</label>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  customInput={<input type="text" className="form-control" />}
                  disabled={contacto ? true : false}
                  selected={fechaNacimiento}
                  onChange={(date) => {
               
                    setFechaNacimiento(date);
                  }}
                />
              </div>
            ) : null}
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default AddContacto;
